<template>
    <v-dialog v-model="dialog" max-width="800" :fullscreen="testMode" persistent>
      <v-card>
          <v-card-title class="primary white--text title">
              {{'Rule'|translate}}
          </v-card-title>
          <v-card-text>
              <v-layout row>

                  <v-flex v-bind:class="[testMode ? 'xs4' : 'xs12']">
                      <v-form v-model="valid">
                      <v-text-field :label="'Title'|translate" autofocus
                                    v-model="activeItem.title" browser-autocomplete="off"
                                    v-bind:rules="fieldRules"></v-text-field>
                      <v-text-field :label="'Description'|translate" autofocus v-model="activeItem.desc"></v-text-field>
                      <v-text-field :label="'Topic'|translate" autofocus v-model="activeItem.topic"></v-text-field>
                          <v-radio-group v-model="activeItem.active_status" :mandatory="true" :label="'Active Status'|translate">
                              <v-radio :label="'Active - rule will be applied'|translate" :value="'active'"></v-radio>
                              <v-radio :label="'Inactive - rule will not run'|translate" :value="'inactive'"></v-radio>
                              <v-radio :label="'Muted - rules will be applied, but notifications (if any) will immediately be acknowledged'|translate" :value="'muted'"></v-radio>
                          </v-radio-group>
                      <v-text-field :label="'Equipment Group'|translate" autofocus
                                    v-model="activeItem.equipment_group"></v-text-field>
                      <v-text-field :label="'Rule'|translate" autofocus v-model="activeItem.rule"></v-text-field>
                      <div v-if="usedParams&&usedParams.length>0">
                          {{'Used parameters'|translate}}
                          <ul>
                              <li v-for="param in usedParams">
                                  {{param.parameter_name}} : {{param.parameter_value}}
                                  <v-icon
                                          small
                                          class="ml-2"
                                          v-if="$can('update', 'Parameter')"
                                          @click="$can('update', 'Parameter') && editParam(param)"
                                  >
                                      fa-edit
                                  </v-icon>
                              </li>
                          </ul>
                          <parameter-record-dialog v-model="paramDialog" :item="editedParam"
                                                   v-on:doreload="refreshpoints()"></parameter-record-dialog>
                      </div>
                          <v-radio-group v-model="activeItem.on" :mandatory="true">
                              <v-radio :label="'Rule Active when Equipment On'|translate" :value="true" color="green"></v-radio>
                              <v-radio :label="'Rule Active when Equipment Off'|translate" :value="false" color="yellow"></v-radio>
                              <v-radio :label="'Rule Active Anytime'|translate" :value="null"></v-radio>
                          </v-radio-group>
                          <severity-selector v-model="activeItem.severity" :label="'Severity'|translate"></severity-selector>
                          <v-text-field :label="'Relevant Variables'|translate" autofocus
                                        v-model="activeItem.relevant_variables"></v-text-field>
                          <v-textarea
                                  :label="'Recommended Action'|translate"
                              v-model="activeItem.recommended_actions"
                              auto-grow
                      ></v-textarea>
                      <v-text-field :label="'Value'|translate" autofocus v-model="activeItem.value"></v-text-field>
                      <v-text-field :label="'Cost'|translate" v-model="activeItem.cost"></v-text-field>
                  </v-form>
                  </v-flex>

                  <v-flex xs8 v-if="testMode" class="pl-5">
                      <date-range-selector v-model="range"></date-range-selector>
                      <equipment-selector  v-model="equip" :typeFilter="activeItem.equipment_group"></equipment-selector>
                      <v-btn class="accent" @click="runTest()" >{{'Run test'|translate}}</v-btn>
                      <v-progress-linear  v-show="loading" :indeterminate="true"></v-progress-linear>
                      <div v-if="showData&&!loading">
                          <fault-eval-widget
                                             :rule="activeItem.rule"
                                             :title="activeItem.title"
                                             :value="activeItem.value"
                                             :equipment-name="equip"
                                             :relevant-variables="activeItem.relevant_variables"
                                             :on-only="activeItem.on"
                                             show-cost
                                             :date-range="range"></fault-eval-widget>
                      </div>

                  </v-flex>
              </v-layout>
          </v-card-text>

          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="primary" @click="addRecord(true)" :disabled="!valid||!$can('update', 'Rule')">{{'Save'|translate}}</v-btn>
              <v-btn class="accent" @click="testMode=true" v-show="!testMode">{{'Test the rule'|translate}}</v-btn>
              <v-btn class="accent" @click="testMode=false" v-show="testMode" >{{'Close testing interface'|translate}}</v-btn>
              <v-btn @click="dialog=false">{{'Cancel'|translate}}</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  import {putRule} from '../../helper'
  import SeveritySelector from "../SeveritySelector";
  import ParameterRecordDialog from "../parameter/ParameterRecordDialog";
  import DateRangeSelector from "../DateRangeSelector";
  import EquipmentSelector from "../EquipmentSelector";
  import moment from 'moment'
  import FaultEvalWidget from "../widgets/FaultEvalWidget";

  export default {
    props: {
      value: {type:Boolean, default: true},
      item: {type: Object, default: null},
      parameter: {type: Array, default: []}
    },
      components:{SeveritySelector,ParameterRecordDialog,DateRangeSelector,EquipmentSelector,FaultEvalWidget},
      computed:{
        usedParams(){
            if(!this.activeItem.rule||this.activeItem.rule==''){
                return []
            } else {
                let used = [];
                for(let param of this.parameter){
                    if(this.activeItem.rule.indexOf(param.parameter_name)>-1){
                        used.push(param)
                    }
                }
                return used;
            }
        }
      },
    watch: {
      item (item) {
        this.initializeVar()
        if (item){
            if(item.severity){
                item.severity=item.severity.toLowerCase()
            }
          this.activeItem = this.item
            if(!this.activeItem.active_status){
                this.activeItem.active_status='active'
            }
        }
      },
      value () {
        if (this.dialog !=this.value){
          this.dialog=this.value
        }
      },
      dialog () {
        this.$emit('input', this.dialog)
          if(!this.item){
              this.initializeVar()
          }
      }
    },
      beforeMount() {
          let maxDate = this.$store.state.pointsListStore.pointsList.data_max_date;
          if (maxDate) {
              this.range = {
                  start: moment(maxDate).subtract(30, "days").format('YYYY-MM-DD'),
                  end: moment(maxDate).format('YYYY-MM-DD')
              }
          }
      },
    data () {
      return {
        dialog: false,
          equip: null,
          valid:false,
          range: {start: moment().subtract(30, "days").format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD')},
          fieldRules: [value => !!value || 'This value is required.',v => v.length < 100 || 'This value cannot be longer than 100 characters.'],
          showData:false,
          testMode:false,
          paramDialog:false,
          loading:false,
          editedParam:null,
        activeItem: {
          desc: '',
            title: '',
          equipment_group: '',
          rule:  '',
          on: 0,
          value: '',
          cost: '',
            severity: 'low',
            relevant_variables: '',
            recommended_actions: '',
          rule_id: null
        } ,

      }
    },
    methods: {
        refreshpoints(){
            this.$emit('refreshpoints')
        },
        runTest(){
            let me=this;
            me.loading=true
            me.showData=false
            setTimeout(function(){me.showData=true; me.loading=false;},100)
        },
        editParam (param) {
            this.editedParam = Object.assign({}, param)
            this.paramDialog = true
        },
      initializeVar(close) {
          this.testMode=false
          this.loading=false
          this.equip=null
          this.showData=false

        this.activeItem = {
          desc: '',
            title: '',
          equipment_group: '',
          rule:  '',
          on: true,
          value: '',
          cost: '',
            severity: 'low',
            topic: 'default',
            active_status: 'active',
            relevant_variables: '',
            recommended_actions: '',
          rule_id: null
        }
          if(close) {
              this.dialog = false;
          }
      },
      async addRecord (close) {
       await putRule(
          {
            'rule_id': this.activeItem.rule_id,
            'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
            'desc': this.activeItem.desc,
            'title': this.activeItem.title,
            'equipment_group': this.activeItem.equipment_group,
            'rule': this.activeItem.rule,
            'on': this.activeItem.on,
            'topic': this.activeItem.topic,
            'active_status': this.activeItem.active_status,
            'value': this.activeItem.value,
            'severity': this.activeItem.severity,
            'relevant_variables': this.activeItem.relevant_variables,
            'recommended_actions': this.activeItem.recommended_actions,
            'cost': this.activeItem.cost
          }
        )
          this.$emit('doreload')
          if(close) {
              this.dialog = false;
          }
      }
    },
    name: 'RuleRecordDialog'
  }
</script>

<style scoped>

</style>
